import { CircularProgress, Divider, Modal } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 12px;
  background: var(--color-back-opacity-10);
  border-radius: 5px;
`;

export const CustomModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;

  .body {
    position: relative;
    background: #fff;
    position: relative;
    background: #fff;
    box-sizing: border-box;
    padding: 12px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 350px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    color: var(--color-navy-blue);
    font-size: 20px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    font-family: Sora, sans-serif;
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);

    svg {
      color: #4f4f4f;
      font-size: 22px;
    }

    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 300px;
  overflow-y: auto;
  padding-right: 4px;

  > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  scrollbar-width: thin;
  scrollbar-color: black transparent;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    padding: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #a1a1a1;
  }

  h2 {
    font-weight: 560;
    font-size: 16px;
    line-height: 16px;
    color: var(--color-blue-medium-dark);
    font-family: Sora, sans-serif;
  }

  h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: var(--color-navy-blue);
    font-family: Sora, sans-serif;

    span {
      color: var(--color-alba-grandeza);
      font-weight: 400;
      font-size: 14px;
    }
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-alba-grandeza);
    font-family: Sora, sans-serif;
  }

  .hours__option {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
    grid-row-gap: 8px;
    grid-column-gap: 8px;
  }

  .seleted__day {
    .react-datepicker {
      border: 2px solid var(--color-gray-900);
    }

    .react-datepicker__header {
      background: transparent;
      border-bottom: 2px solid var(--color-gray-900);
    }

    .react-datepicker__day-name {
      color: var(--color-red);
      font-family: Sora;
      font-weight: 600;
      font-size: 12px;
    }

    .react-datepicker__current-month {
      color: var(--color-blue);
    }

    .react-datepicker__triangle {
      border-bottom-color: var(--color-gray-900);
      left: 100px !important;
    }

    .react-datepicker__triangle::before {
      display: none;
    }

    .react-datepicker__navigation--next {
      border-left-color: var(--color-blue);
    }

    .react-datepicker__navigation--previous {
      border-right-color: var(--color-blue);
    }

    .react-datepicker__current-month {
      font-family: Sora;
      font-size: 16px;
      text-transform: uppercase;
      color: var(--color-blue);
    }

    .react-datepicker__day {
      color: var(--color-navy-blue);
      font-family: Sora;
      font-weight: 500;
    }

    .react-datepicker__day--disabled {
      cursor: default;
      color: var(--color-gray-800);
    }

    .react-datepicker__day--selected {
      background-color: var(--color-blue);
      color: #fff;
    }

    .react-datepicker__day--keyboard-selected {
      background-color: transparent;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  user-select: none;
`;

export const CustomDivider = styled(Divider)`
  width: 100%;
  background: var(--color-gray-900);
`;

export const CustomCaledar = styled.button`
  border: 2px solid var(--color-gray-900);
  border-radius: 5px;
  padding: 8px;
  user-select: none;
  cursor: pointer;
  background-color: transparent;
  width: auto;
  height: min-content;
  display: flex;
  gap: 4px;
  align-items: center;
  border-color: var(--color-blue);

  svg {
    color: var(--color-blue);
  }
`;

export const OptionItem = styled.button<{ selected?: boolean }>`
  border: 2px solid var(--color-gray-900);
  border-radius: 5px;
  padding: 4px;
  user-select: none;
  cursor: pointer;
  background-color: transparent;
  width: min-content;
  height: min-content;
  transition: all 0.2s ease-in-out;

  p {
    font-weight: 600;
  }

  :hover {
    border-color: var(--color-blue-opacity-50);
  }

  ${(p) =>
    p.selected &&
    css`
      border-color: var(--color-blue) !important;

      p {
        color: var(--color-blue) !important;
      }
    `}
`;

export const CustomCircularProgress = styled(CircularProgress)`
  color: var(--color-blue);
`;
